import { formatDate } from '@angular/common';

export function csszDateFormat(date: Date | null | undefined): string | null {
    return date ? formatDate(date, 'yyyy-MM-dd', 'en-US') : null;
}

export function csszTimeFormat(date: string | null | undefined): string | null {
    return date ? formatDate(date, 'HH:mm:ss', 'en-US') : null;
}
